import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {RawTariffDto} from '../../api';
import {api} from '../../api';
import {createQuerySuspense} from '../../lib';

const {getBillingTariffs} = api.billing;

const getBillingTariffsRefresh = atom<number>({
  key: 'getBillingTariffsRefresh',
  default: 0,
});

const getBillingTariffsQuery = selectorFamily<RawTariffDto[], null>({
  key: 'getBillingTariffsQuery',
  get:
    () =>
    async ({get}) => {
      get(getBillingTariffsRefresh);
      try {
        const {data} = await getBillingTariffs();
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    },
});

export const useGetBillingTariffsQuerySuspense = createQuerySuspense(getBillingTariffsQuery, getBillingTariffsRefresh);
